import { render } from "./Copyright.vue?vue&type=template&id=5c94210a&scoped=true&ts=true"
import script from "./Copyright.vue?vue&type=script&lang=ts"
export * from "./Copyright.vue?vue&type=script&lang=ts"

import "./Copyright.vue?vue&type=style&index=0&id=5c94210a&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c94210a"]])

export default __exports__